

//import { createExtractorFromData, UnrarError } from 'node-unrar-js' 
import { createExtractorFromData } from 'node-unrar-js' 
import { CreateDirectories, createFileListItem, gaEvent, safeFilename, isSafeFile } from './Utils' 
import DropboxService from './DropboxService' 


export default class _RARService {
    archiveFile = null;
    fileList = new Set();
    unfilteredCount;
    filter;
    encrypted = false;
    extractor;
    dbxService;
    password;
    
    constructor(archiveFile, filter) {
        this.archiveFile = archiveFile;
        this.filter = filter;
        //console.log('Filter set to', this.filter);
    }

    getUnfilteredCount() {
        return this.unfilteredCount;
    }

    async setPassword(password) {
        this.password = password;
        this.fileList = new Set();
        return this.getFileList(true);
    }
    
    getExtractedFiles() {
        return window._extractor.extract({ files: () => true });
    }

    async getFileList(reset) {
        if (reset || !this.fileList.length) {
            this.fileList = new Set();
            let data = await this.archiveFile.arrayBuffer();
            // Using this... https://github.com/YuJianrong/node-unrar.js
            const wasmBinary = await (
            await fetch('/assets/unrar2.wasm', { credentials: 'same-origin' })
            ).arrayBuffer();
            let options = { wasmBinary, data };
            if (this.password) {
                options.password = this.password;
            }
            let extractor = await createExtractorFromData(options);            
            window._extractor = extractor; // TODO: Should be a class instance but was screwing up :-/             
            let fileHeaders ;
            
            try {                
                fileHeaders =  window._extractor.getFileList().fileHeaders;                
            } catch(fileExtractError) {
                // Password for encrypted file
                console.log('_RARService:fileExtractError', fileExtractError.message);
                fileHeaders = [];
                if (fileExtractError.message && fileExtractError.message.indexOf('Password for encrypted file') > -1) {
                    this.encrypted = true;

                } else {
                    throw fileExtractError;
                }
            }            
            let fileCount = 0;            
            for (const fileHeader of fileHeaders) {                
                                
                
                if (fileHeader.flags.encrypted) {
                    this.encrypted = true;
                }
            
                if (isSafeFile(fileHeader.name)) {
                    const ext = fileHeader.name;
                    
                    if(!this.filter || ext.indexOf(this.filter) > -1) {
                        this.fileList.add(createFileListItem(fileHeader.name, fileHeader.flags.directory, fileHeader.unpSize));
                    }
                    if (!fileHeader.flags.directory) {
                        fileCount++; 
                    }
                }
             }
             this.unfilteredCount = fileCount;             
            return this.fileList;             
        } else {
            return this.fileList;
        }
    }

    isEncrypted() {
        return this.encrypted;
    }

    getFileData(file) {
        const filePath = file.fileHeader.name;        
        let blob = new Blob([file.extraction]);
        return {filePath, blob};
    }

    processAllFiles(callback) {
        let fileCounter = 0;
        let totalFiles = this.fileList.size;        
        for (const file of this.getExtractedFiles()) {                        
            const fileHeader = file.fileHeader;
            const filePath = fileHeader.name;                            
            // progressUpdateFn({currentFile: filePath, progress: fileCounter === 0? 0 : (fileCounter/totalFiles)*100}); // TODO: Maybe check to see that this is a function?                                                                                                                               
            let blob = new Blob([file.extraction]);       
            let progress = fileCounter === 0? 0 : (fileCounter/totalFiles)*100;     
            callback(filePath, progress, blob);            
            fileCounter++;
        }
    }

    async saveAll(outputDir, progressUpdateFn) {
        // Uncomment to use the spec-provided sandbox folder:
        // const outputDir = await FileSystemDirectoryHandle.getSystemDirectory({ type: "sandbox" });
        if (outputDir === '') {
            console.log("No output directory selected, please select an output directory first");
            return;
        }
        const { files } = window._extractor.extract({ files: () => true });
        let writer;
        let fileCounter = 0;
        //let totalFiles = this.fileList.size; // WARNING: This might not always be the total count!!!
        let totalFiles = this.unfilteredCount;
        let unallowedFiles = [];
        for (const file of files) {                        
            const fileHeader = file.fileHeader;
            const ext = fileHeader.name.split('.').pop();

            if (isSafeFile(file.fileHeader.name) && (!this.filter || ext.indexOf(this.filter) > -1) ) {
                const filePath = safeFilename(fileHeader.name);
                const [dir, fileName] = await CreateDirectories(outputDir, filePath);

                // Try to get |file_name| in |dir|.  If this doesn't reject,
                // then |file_name| exists.
                let exists;  // eslint-disable-line
                try {
                    'getFile' in dir ? await dir.getFile(fileName, {create: false}) : await dir.getFileHandle(fileName, {create: false});
                    exists = true;
                } catch(e) {
                    // Continue.
                    exists = false;
                }
                try {
                    const outputFile = 'getFile' in dir ? await dir.getFile(fileName, {create: true}) : await dir.getFileHandle(fileName, {create: true});                                    
                    progressUpdateFn({currentFile: filePath, progress: fileCounter === 0? 0 : (fileCounter/totalFiles)*100}); // TODO: Maybe check to see that this is a function?                
                    writer = await outputFile.createWritable({keepExistingData: false});
                    let blob = new Blob([file.extraction]);
                    const stream = blob.stream();
                    await stream.pipeTo(writer);                
                } catch (ex) {
                    if(ex.message && ex.message.indexOf('Name is not allowed') > -1) {                    
                        console.log(ex);                    
                        unallowedFiles.push(createFileListItem(fileHeader.name, fileHeader.flags.directory, fileHeader.unpSize));
                        gaEvent('name-not-allowed-warning', filePath); 
                    }else if(ex.message && ex.message.indexOf('Safe Browsing')) {
                        console.log(ex);                    
                        unallowedFiles.push(createFileListItem(fileHeader.name, fileHeader.flags.directory, fileHeader.unpSize));
                        gaEvent('name-not-allowed2-warning', filePath);
                    } else {
                        gaEvent('rar-save-all-error', filePath);
                        throw ex;
                    }                
                }
            }
            fileCounter++;
        }
        return {unallowedFiles};
    }
    
    async saveAllToDropbox(progressUpdateFn) {
        if(!this.dbxService) {
            this.dbxService = new DropboxService();
        }
        const { files } = window._extractor.extract({ files: () => true });
        
        let fileCounter = 0;
        let totalFiles = this.fileList.size; // WARNING: This might not always be the total count!!!
        
        for (const file of files) {            
            
            const ext = file.fileHeader.name.split('.').pop();

            if (isSafeFile(file.fileHeader.name) && (!this.filter || ext.indexOf(this.filter) > -1) ) {
                let blob = new Blob([file.extraction.buffer]); 
                const filePath = safeFilename(file.fileHeader.name);
                progressUpdateFn({currentFile: filePath, progress: fileCounter === 0? 0 : (fileCounter/totalFiles)*100 });            
                await this.dbxService.uploadFile(filePath, blob);            
            }                        
            fileCounter++;
        }
    }

    async saveFileToDropbox(fullpath) {        
        if(!this.dbxService) {
            this.dbxService = new DropboxService();
        }        
        let blob = await this.extractFile(fullpath);
        // Individual files aren't saved with full path...
        let name = safeFilename(fullpath.split('/').pop());                
        return this.dbxService.uploadFile(name, blob); 
    }

    async extractFile(filename) {        
        const extracted = window._extractor.extract({ files: [filename] });
        const files = [...extracted.files]; //load the files        
        return new Blob([files[0].extraction.buffer]);        
    }    
}